// Todo:
// * Convert renderbooths to a component.
// * Convert renderMarkers to a component.
/*eslint-disable no-undef*/
import L,{divIcon,CRS, rectangle} from 'leaflet';
import "leaflet-draw/dist/leaflet.draw.css";
import "leaflet/dist/leaflet.css";
import React from 'react';
import { connect } from "react-redux";
import {Modal, Button,} from 'react-bootstrap';
import {Map as LeafletMap, Popup, ImageOverlay, FeatureGroup, Rectangle, Polygon, Marker, Tooltip} from 'react-leaflet';
import { EditControl } from "react-leaflet-draw";
import _map from "lodash/map";
import _filter from "lodash/filter";
import _isEmpty from "lodash/isEmpty";
import _isEqual from "lodash/isEqual";
import _sortBy from "lodash/sortBy";
import _find from "lodash/find";
import { ExhibitorProfile, ConfirmationModal, ErrorModal } from '../Modals';
import { Cart } from '../Cart';
import ExhibitorList from './Exhibitors';
import Search from '../directory/Search';
import {handleBoothListLoader} from '../../appRedux/actions/ExhibitorFloor';
import { Tabs,Card,Row,Col,Drawer,Spin } from 'antd';
import { LoadingOutlined, WarningOutlined } from '@ant-design/icons';
import "antd/dist/antd.compact.css";

const { TabPane } = Tabs;

const displayConstants = {
    /******
     * minZoomConstant represents the percentage extra space around the map when you are 
     * zoomed out as much as possible (0.05 = 5%). May want to configure in admin site in the future. 
     * For now hard-coded.
     */
    minZoomConstant:0.05,
    /*****
     * maxZoomConstant represents the maximum height the smallest booth can have (in pixels).
     * May require further experimentation or refactoring for relativity to viewHeight
     */
    maxZoomConstant: 200
}

if (masterapp.startsWith("http")) {
    var api_url = masterapp + "/admin2015/exhibitors/new_floorplan/booth_ajax.cfc";
    var cart_api_url =  masterapp + "/exhibitor_v2/floorplan_v2/cart_ajax.cfm";
} else {
    var api_url = "/" + masterapp + "/admin2015/exhibitors/new_floorplan/booth_ajax.cfc";
    var cart_api_url =  "/" +  masterapp + "/exhibitor_v2/floorplan_v2/cart_ajax.cfm";
}

// util methods
const getMethods = (obj) => {
    let properties = new Set()
    let currentObj = obj
    do {
        Object.getOwnPropertyNames(currentObj).map(item => properties.add(item))
    } while ((currentObj = Object.getPrototypeOf(currentObj)))
    return [...properties.keys()].filter(item => typeof obj[item] === 'function')
}

var guideLayers = new Array();

class LMap extends React.Component {
    // Constructor
    constructor() {
        super();
        this.state = {
            showNewBoothModal: false,
            showExhibitorModal: false,
            lastDrawingEvent: null,
            form: {
                ConfID: ConfID, //NTBJ
                Class: 'Booth',
                Confirmed: 0
            },
            exhibitors: [],
            fontSize: 8,
            showCompany: false,
            editMode: false,
            disableZoom: false,
            zoom: 0,
            booths: {},
            labels: {},
            undrawn_booths: [],
            undrawnMapped: false,
            modalType: 'new',
            populatedForm: {},
            unmapped_booths: {},
            legacy_booths: {},
            ConfID: ConfID,
            activeTab: 1,
            discounts: [],
            selectedExhibitor: null,
            filterText: '',
            onlySponsor: false,
            selectedBoothID: 0,
            headerHeight: 100,
            color: {
                taken: "#fffac8",
                available: "#aaffc3"
            },
            booth_color: {},
            cartList: [],
            registeredList: [],
            showError: false,
            advancedSearch: {},
            exhibitorsInfo: {},
            drawerVisible:false,
            isAdvancedSearch: false,
            isExhibtorButton:false,
            fontMultiplier: 1
        };

        // binds
        this.handleShow = this.handleShow.bind(this);
        this.cancel = this.cancel.bind(this);
        this.saveBooth = this.saveBooth.bind(this);
        this.onCreated = this.onCreated.bind(this);
        this.onEdited = this.onEdited.bind(this);
        this.changeHandler = this.changeHandler.bind(this);
        this.onZoomChange = this.onZoomChange.bind(this);
        this.editToggle = this.editToggle.bind(this);
        this.selectPolygon = this.selectPolygon.bind(this);
        this.delete = this.delete.bind(this);
        this.handleExhibitorModalClose = this.handleExhibitorModalClose.bind(this);
        this.openCompanyPopup = this.openCompanyPopup.bind(this);
        this.highlightBooth = this.highlightBooth.bind(this);
        this.filterChangeHandler = this.filterChangeHandler.bind(this);
        this.addToCart = this.addToCart.bind(this);
        this.removeFromCart = this.removeFromCart.bind(this);
        this.handleErrorModalClose = this.handleErrorModalClose.bind(this);
        this.initializeLabelProperties = this.initializeLabelProperties.bind(this);

        // loads
        this.load_booths();

        // refs
        this.featureGroup = React.createRef();
    }

    editToggle = event => {
        if (!this.state.editMode) {
            this.setState({
                editMode: true,
                disableZoom: true,
                fontSize: 16,
                showCompany: false
            });
        } else {
            this.setState({
                editMode: false,
                disableZoom: false,
                fontSize: this.setTextSize(this.state.zoom)
            });
        }
    }

    // Invoked from componentDidMount()
    updateDimensions() {
        const height = window.innerWidth >= 992 ? window.innerHeight : 400;
        this.setState({
            height: height
        });
    }

    // Lifecycle
    componentWillMount() {
        this.updateDimensions();
    }


    // Lifecycle
    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions.bind(this));
    }

    numberWithCommas(x) {
        if(x){
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        } else return null;
    }

    load_booths() {
        // If mode is cart, let's load registerd booths ValueIDs
        this.load_registered_booths().then((registered) => {
            let registeredList = [];
            // load booths for the set conference.
            // also segregate legacy booths from  the compatible `to this app` booths.
            let sending_data = {
                ConfID: this.props.ConfID
            };
            this.props.handleBoothListLoader(true);
            fetch(api_url + "?method=getBooths&returnFormat=json&Source=" + this.props.source_hex, {
                body: JSON.stringify(sending_data),
                method: "POST"
            }).then(function(response) {
                return response.json()
            }).then(function(data) {
                this.props.handleBoothListLoader(false);
                let undrawn_booths = [];
                let legacy_booths = {};
                let labels = {};
                Object.keys(data).map((key) => {
                    if(data[key].hasOwnProperty('DrawBounds')){
                        // if the booth is part of new floorplan app.
                        data[key]['DrawBounds'] = JSON.parse(data[key]['DrawBounds']);

                        // we don't have label bounds as well, but some computed and fixed 
                        // label properties can be set now.
                        let fixedLabelProperties = this.initializeLabelProperties(data[key]['DrawBounds']['polygon'][0])
                        labels[data[key]['BoothID']] = fixedLabelProperties;
                        
                        undrawn_booths.push(data[key]);

                        // Handling CheckOutDateTime
                        let CheckOutDateTime = Date.parse(data[key]['CheckOutDateTime']);
                        if(CheckOutDateTime) {
                            let now = Date.parse(new Date());
                            let diff = (now - CheckOutDateTime) / 60000;
                            if(typeof CheckoutLength !== 'undefined') {
                                if(diff < CheckoutLength && data[key]['Confirmed'] != 1) {
                                    data[key]['CompID'] = 99999;
                                }
                            }

                        }
                        if(data[key].hasOwnProperty('ValueID') && registered.includes(data[key]['ValueID']))
                        {
                            registeredList.push({...data[key]});
                        }
                    } else {
                        // assuming legacy booth.
                        legacy_booths = {...legacy_booths, [data[key]['BoothID']]: data[key] };
                    }
                });
                this.setState({
                    undrawn_booths: undrawn_booths,
                    legacy_booths: legacy_booths,
                    labels: labels,
                    registeredList: registeredList
                });
                this.mapUndrawnBooths(false);
            }.bind(this));
        })
    }

    // load_registered_booths() {
    //     if(mode == 'cart') {
    //         this.setState({registeredList: });
    //     }
    // }

    // cancel model handler
    cancel() {
        if (this.state.modalType == 'new') {
            if (this.state.lastDrawingEvent.hasOwnProperty('layer')) {
                this.state.lastDrawingEvent.layer.remove();
            }
            this.setState({
                lastDrawingEvent: null,
                labelLocation: null
            });
        }
        this.setState({
            showNewBoothModal: false
        });
        this.setState({
            form: {},
            populatedForm: {},
        });
    }

    checkBoothClass = (aBooth, isCustomClass = false) => {
        if (isCustomClass) {
            return aBooth == 'Booth'
        }
        return (aBooth == 'Booth' || aBooth != 'Pathway')
    }

    handleShow() {
        this.setState({
            showNewBoothModal: true
        });
    }

    ajaxCallCart(action, data) {
        let sending_data = {...data, SESSION: SESSION};
        return fetch(cart_api_url + "?action="  + action + "&Source=" + this.props.source_hex, {
            body: JSON.stringify(sending_data),
            method: "POST"
        }).then(function(response) {
            return response.json()
        }).then(function(data) {
            return data;
        }.bind(this));
    }

    async load_registered_booths() {
        if(mode == 'cart'){
            const result = await this.ajaxCallCart('getRegisteredBooths', {});
            return result;
        } else {
            return []; // we don't want to populate this variable if mode is not cart.
        }
    }

    addToCart(booth) {
        this.ajaxCallCart('addToCart', {ValueID: booth['booth_data']['ValueID']}).then((result) =>{
            if(result['success']) {
                this.state.cartList.push(booth);
                booth['polygon_layer'].setStyle({
                    fillColor: this.state.color['taken'],
                    color: "#ffa769",
                    opacity: 1,
                    fillOpacity: 1,
                    weight: 3
                });
                this.setState({cartList: this.state.cartList});
            } else {
                booth['polygon_layer'].setStyle({
                    fillColor: this.state.color['taken'],
                    color: "#000",
                    opacity: 1,
                    fillOpacity: 1,
                    weight: 2
                });
                this.state.booths[booth['booth_data'].BoothID]['booth_data'].CompID = 999999;
                this.setState({booths: this.state.booths, showError: true, errorText: 'Sorry, the booth are you trying to add is no longer available.'});
            }
        });

    }
    removeFromCart(booth) {
        this.ajaxCallCart('removeFromCart', {ValueID: booth['booth_data']['ValueID']}).then((result) => {
            if(result['success']) {
                booth['polygon_layer'].setStyle({
                    fillColor: this.state.color['available'],
                    color: "#000",
                    opacity: 1,
                    fillOpacity: 1,
                    weight: 2
                });
                if(this.state.cartList.indexOf(booth) != -1) {
                    this.state.cartList.splice(this.state.cartList.indexOf(booth), 1);
                }
                if(this.state.registeredList.indexOf(booth['booth_data']) != -1) {
                    this.state.registeredList.splice(this.state.registeredList.indexOf(booth['booth_data']), 1);
                }
                // Handling registeredList
                let target_index = -1;
                for(let i in this.state.registeredList) {
                    if(this.state.registeredList[i]['BoothID'] == booth['booth_data']['BoothID']){
                        target_index = i;
                    }
                }
                if(target_index != -1) {
                    this.state.registeredList.splice(target_index, 1);
                }
                this.setState({cartList: this.state.cartList, registeredBooths: this.state.registeredList});
            } else {
                this.setState({showError: true, errorText: 'Sorry, unable to remove the booth from your cart'});
            }
        });

    }

    initializeLabelProperties(boothBounds) {

        let lngMin = boothBounds[0].lng, lngMax = boothBounds[0].lng;
        let latMin = boothBounds[0].lat, latMax = boothBounds[0].lat;

        boothBounds.forEach( (vertex) => {
            if (vertex.lng < lngMin) {
                lngMin = vertex.lng
            }
            if (vertex.lng > lngMax) {
                lngMax = vertex.lng
            }
            if (vertex.lat < latMin) {
                latMin = vertex.lat
            }
            if (vertex.lat > latMax) {
                latMax = vertex.lat
            }
        })

        const latPos = ((latMax-latMin) / 2) + latMin
        const lngPos = ((lngMax-lngMin) / 2) + lngMin

        return {
            baseSize: {
                width: lngMax - lngMin,
                height: latMax - latMin
            },
            position: {
                lat: latPos,
                lng: lngPos
            }
        }
    } 
    // Render: Marker
    renderMarkers() {
        const renderToolTip = (lat,lng) => {
            let position;
            let image_lng = this.props.image_width;
            let overLayLat = this.props.image_height / 2; 
            let overLayLng = this.props.image_width / 2;
            if(lat > overLayLat){
                if(lng < (overLayLng * 1/4)){
                    return position = 'right'
                }else if(lng > (image_lng * 3/4)){
                    return position = 'left'
                }
                return position = 'bottom'
            }else{
                if(lng < (overLayLng * 1/4)){
                    return position = 'right'
                }else if(lng > (image_lng * 3/4)){
                    return position = 'left'
                }
                return position = 'top'
            }
        }
        return Object.keys(this.state.labels).map((booth_id) => {
            let popUp = this.state.undrawn_booths.map((work_booth) => {
                if (`${work_booth['BoothID']}` === booth_id) {
                    let companyname = 'Unassigned';
                    let companyLogo = '';
                    let lat = work_booth.DrawBounds.label.lat;
                    let lng = work_booth.DrawBounds.label.lng;
                    if (!work_booth.hasOwnProperty('CompID') || work_booth['CompID'] != 0) {
                        if (this.props.exhibitors.hasOwnProperty(work_booth['CompID'])) {
                            companyname = this.props.exhibitors[work_booth['CompID']].Companyname;
                            companyLogo = this.props.exhibitors[work_booth['CompID']].CompLogo
                        }else if(work_booth['CompID']){
                            companyname = 'Company details not found'
                        }
                    }
                    return (<Tooltip key={booth_id} opacity={1} className='floorplan-tooltip' sticky direction={renderToolTip(lat, lng)}>
                        {fullscreen && this.props.exhibitors[work_booth['CompID']] && this.props.exhibitors[work_booth['CompID']].CompLogo && (<img src={companyLogo} style={{ height: '100%', width: '100%' }} />)}
                        {(work_booth['CompID'] && !this.props.exhibitors.hasOwnProperty(work_booth['CompID'])) && <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <WarningOutlined style={{ fontSize: '30px' }} />
                        </div>}
                        <h4 className='gx-my-2'><b>{companyname}</b></h4>
                        <br /><div>Booth: {work_booth.BoothNo}</div>
                        Size: {work_booth['BoothSize']}<br />
                        {this.props.exhibitors[work_booth['CompID']] && this.props.exhibitors[work_booth['CompID']].sponsor && (<span className="label label-info">Sponsor</span>)}
                        {this.props.mode == 'cart' && !(work_booth.hasOwnProperty('CompID') && work_booth.CompID != 0) && show_cost && (<div>Cost: ${this.numberWithCommas(work_booth['Amount'])}</div>)}
                    </Tooltip>)
                }
            })
                if (this.state.booths.hasOwnProperty(booth_id)) {
                    // let's create a booth obj for convinence.
                    let booth_obj = this.state.booths[booth_id]['booth_data'];
                    let company_label = "";
                    if (this.state.showCompany) {
                        // if booth object has CompID
                        if (booth_obj.hasOwnProperty('CompID')) {
                            //if we have information on this CompID
                            if (this.props.exhibitors.hasOwnProperty(booth_obj.CompID)) {
                                // yes, we do have.
                                company_label = this.props.exhibitors[booth_obj.CompID].Companyname.replace(" ", "&nbsp;");
                            }
                        }
                    } else {
                        company_label = "";
                    }
                    let booth_no = '';

                    let color_key = 'taken';
                    if (this.checkBoothClass(booth_obj.Class, true)) {
                        if (booth_obj.hasOwnProperty('CompID') && booth_obj.CompID !=0 ) {
                            // this is a taken booth.
                            color_key = 'taken';
                        } else {
                            // else booth is available.
                            color_key = 'available';
                        }
                    } else {
                        color_key = booth_obj.Class;
                    }

                    if(booth_obj.hasOwnProperty('BoothNo')){
                    if(this.state.color[color_key] != 'transparent')
                    booth_no = booth_obj['BoothNo'].toString().replace(' ', '&nbsp;');
                    } else {
                        booth_no = 'Not&nbsp;Set';
                    }
                    // if(booth_obj.hasOwnProperty('OnHold')){
                    //     if(booth_obj['OnHold'] == 1) {
                    //         booth_no = booth_no + "(on&nbsp;hold)";
                    //     }
                    // }
                    const icon = divIcon({
                        className: 'map-label',
                        // iconSize: null,
                        iconAnchor: booth_obj['DrawBounds']['label'],
                        html: `<div style='font-size: ${this.state.fontSize}px; text-align: center !important;'><b>${booth_no}</b><br>${company_label}</div>`
                    });
                    return (
                            <Marker
                            position={booth_obj['DrawBounds']['label']}
                            icon={icon}
                            key={booth_id}
                            alt={booth_id}
                            // onMouseOver={(e) => {
                            //   this.state.booths[booth_id].polygon_layer.openPopup();
                            // }}
                            onClick={(e)=> {
                                this.selectPolygon({'layer': this.state.booths[booth_id].polygon_layer});
                            }}
                            >
                                {popUp}
                            </Marker>);
                } else {
                    return null;
                }
        });
    }

    // Action called from create booth modal.
    // Objective of the method is to call createBooth method in coldfusion.
    // + update action.
    saveBooth(e) {
        // e is form here.
        if (e.currentTarget.checkValidity()) {
            this.setState({
                showNewBoothModal: false,
                text: 'Syncing changes...'
            });

            console.log('make ajax call to server to save the new booth');
            e.preventDefault();
            e.stopPropagation();
            this.updateBooth();
        }
    }

    resetForm(){
        // Appending DiscountID
        let discounts = {};
        if(this.state.discounts.length > 0) {
            for(let i=1;i<=this.state.discounts.length;i++){
                discounts['Discount' + i] = this.state.discounts[i-1]['DiscountID'];
            }
        }
        this.setState({form:{...discounts,
             ConfID: this.props.ConfID, Class: 'Booth', Confirmed: 0, FloorplanID: floorplan_id}, populatedForm:{}, activeTab : 1});
    }

    updateBooth() {

        let discounts = {};
        if(this.state.discounts.length > 0) {
            for(let i=1;i<=this.state.discounts.length;i++){
                discounts['Discount' + i] = this.state.discounts[i-1]['DiscountID'];
            }
        }
        // If transfer of booth is requested.
        if(this.state.activeTab == 2) {
            // populate form with data from legacybooths
            this.state.form.legacy_BoothID = parseInt(this.state.form.legacy_BoothID);
            this.state.form = {...this.state.legacy_booths[this.state.form.legacy_BoothID]};
        }

        // Fix empty CompID to null.
        if (this.state.form.hasOwnProperty('CompID')) {
            if (this.state.form.CompID == '') {
                this.state.form.CompID = null;
            }
        }
        let sending_data = {};
        // Handling Drawing bounds for new booth.
        if (this.state.modalType == 'new') {
            sending_data = {...this.state.form,
                ...discounts,
                    DrawBounds: JSON.stringify({
                    polygon: this.state.lastDrawingEvent.layer.getLatLngs(),
                    label: this.state.labelLocation
                }),
            };
        } else if (this.state.modalType == 'update') {
            // Handing Drawing bounds for existing booth.
            sending_data = {...this.state.form,
                ...discounts,
                DrawBounds: JSON.stringify(this.state.booths[this.state.form['BoothID']]['booth_data']['DrawBounds'])
            };
        }
        if(sending_data.CompID == 999999) {
            sending_data["OnHold"] = 1;
            sending_data["Confirmed"] = 1;
        } else if(!sending_data.CompID) {
            sending_data["OnHold"] = 0;
            sending_data["Confirmed"] = 0;
        } else {
            sending_data["OnHold"] = 0;
            sending_data["Confirmed"] = 1;
        }
        fetch(api_url + "?method=createBooth&returnFormat=json&Source=" + source_hex, {
            body: JSON.stringify(sending_data),
            method: "POST"
        }).then(function(response) {
            return response.json()
        }).then(function(data) {
            this.setState({
                text: 'Changes synced'
            });
            let t_data = data;
            t_data['DrawBounds'] = JSON.parse(t_data['DrawBounds']);
            // Sync newly created booth with local list of booth list.
            if (!this.state.booths.hasOwnProperty(data.BoothID)) {
                this.setState({
                    booths: {
                        ...this.state.booths,
                        [data.BoothID]: {
                            'booth_data': t_data,
                            'polygon_layer': this.state.lastDrawingEvent.layer
                        }
                    }
                });
                this.drawBooth(data, this.state.lastDrawingEvent.layer);
            } else {
                this.setState({
                    booths: {
                        ...this.state.booths,
                        [data.BoothID]: {
                            'booth_data': t_data,
                            'polygon_layer': this.state.booths[data.BoothID]['polygon_layer']
                        }
                    }
                });
                this.drawBooth(data, this.state.booths[data.BoothID]['polygon_layer']);
            }
            // if transfering legacy booth.
            if(this.state.activeTab == 2){
                delete this.state.legacy_booths[data.BoothID];
                this.setState({legacy_booths: this.state.legacy_booths});
            }
            // clearing the form state.
            this.resetForm();
        }.bind(this));

    }



    // delete booth.
    delete() {
      let booth_id = this.state.form.BoothID;
      let sending_data = {'BoothID': this.state.form.BoothID};
      this.setState({showNewBoothModal: false});
      this.state.booths[booth_id].polygon_layer.remove();
      fetch(api_url + "?method=delete&returnFormat=json&Source=" + this.props.source_hex, {
          body: JSON.stringify(sending_data),
          method: "POST"
      }).then(function(response) {
          return response.json()
      }).then(function(data) {


          delete this.state.labels[booth_id];
          delete this.state.booths[booth_id];
          this.state.form = {};
          this.state.populatedForm = {};
          this.showNewBoothModal = false;
          this.setState(()=>{return this.state});
      }.bind(this));
    }

    // Draw booth method
    // well the polygon is already been drawn on layer
    // we set some extra parameters based on coldfusion
    // feedback.
    drawBooth(booth_obj, polygon_layer) {
        console.log('Drawing newly created booth');
        let color_key = '';
        if (this.checkBoothClass(booth_obj.Class, true)) {
            if (booth_obj.hasOwnProperty('CompID')) {
                // this is a taken booth.
                color_key = 'taken';
            } else {
                // else booth is available.
                color_key = 'available';
            }
        } else {
            color_key = booth_obj.Class;
        }
        polygon_layer.setStyle({
            fillColor: this.state.color[color_key],
            color: "#000",
            opacity: 1,
            fillOpacity: 1,
            weight: 2
        });
        // append booth_id to label
        this.setState({labels: {...this.state.labels, [booth_obj.BoothID]: {}} });
    }

    // ToDo
    // Method to get list of existing booth objects.
    listBooths() {
    }

    changeHandler = event => {
        const name = event.target.name;
        const value =
            event.target.value;
        // let extra = {};
        // if (this.state.populatedForm.hasOwnProperty('booth_data')) {
        //     extra = {
        //         booth_data: {...this.state.populatedForm.booth_data,
        //             [name]: value
        //         }
        //     };
        // }
        this.setState({
            form: {
                ...this.state.form,
                [name]: value
              }
            // },
            // populatedForm: {...extra
            // }
        });

    }


    onCreated = event => {
        //clear form
        this.resetForm();
        console.log('onCreated');
        // Center of the polygon drawn (or rectange which is a disciplined polygon with neat 90 degree).
        let polygon_center = event.layer.getCenter();
        let temp_cords = [...event.layer.getLatLngs()[0]];
        // Sorting coordinates to get left and top most coordinate of polygon,
        // which will act anchor to our exhibitor label.
        temp_cords.sort((a, b) => (a.lat > b.lat) ? 1 : -1);
        temp_cords.sort((a, b) => (a.lng > b.lng) ? 1 : -1);
        // Average out coordinate to
        // suggest label location.
        let suggested_label_location = {
            lat: (temp_cords[0]['lat'] + polygon_center['lat']) / 2,
            lng: (temp_cords[0]['lng'] + polygon_center['lng']) / 2
        };
        // setting state of `show` which hopefully render
        // modal with form to create a new form.
        console.log("opening up new booth model");
        this.setState({showNewBoothModal: true,modalType: 'new'});
        this.setState({
            lastDrawingEvent: event,
            labelLocation: suggested_label_location
        });
        // /console.log(event.layer.remove());
        //event.stopPropagation();
    }

    onEdited = event => {
        Object.keys(event.layers._layers).map((layer_id) => {
            let sending_data = {};
            let layer = event.layers._layers[layer_id];
            //determine type
            // responsibility of each condition is to curate sending_data
            if (event.layers._layers[layer_id].hasOwnProperty('dragging') &&
                event.layers._layers[layer_id]['dragging'].hasOwnProperty('_marker')) {
                // it is marker
                let booth_id = parseInt(layer.options.alt);
                let new_location = layer._latlng;
                let booth = {...this.state.booths[booth_id]['booth_data']};
                booth['DrawBounds']['label'] = new_location;
                sending_data = booth;
                sending_data['DrawBounds'] = JSON.stringify(sending_data['DrawBounds']);
            } else {
              //it has to be shape

              Object.keys(this.state.booths).map((booth_id) => {
                if(this.state.booths[booth_id].polygon_layer == layer){
                  let booth = {...this.state.booths[booth_id]['booth_data']};
                  let new_location = layer._latlngs;
                  booth['DrawBounds']['polygon'] = new_location;
                  sending_data = booth;
                  sending_data['DrawBounds'] = JSON.stringify(sending_data['DrawBounds']);
                }
              })
            }
            fetch(api_url + "?method=createBooth&returnFormat=json&Source=" + this.props.source_hex, {
                body: JSON.stringify(sending_data),
                method: "POST"
            }).then(function(response) {
                return response.json()
            }).then(function(data) {
                this.setState({
                    text: 'Changes synced'
                });
            }.bind(this));
        });
    }

    // Function for rendering the companies for the drop down.
    // Fulfilling expecation set by load_exhibitors.
    renderCompanies = () => {
        let return_array = [];
        Object.keys(this.props.exhibitors).map((key, index) => {
          return_array.push({key: key, value:  this.props.exhibitors[key].Companyname});
        });
        return_array.sort(function(a, b){
            return a.value.localeCompare(b.value);
        })

        return return_array.map((key, index)=>{
             return (<option value={key.key} key={key.key}>{key.value}</option>);
        });
    }

    // On zoom change, we need to adjust the font size
    // because people can get cranky with small font sizes.
    setTextSize = (zoom_level, fontMultiplier = this.state.fontMultiplier) => {
        let img_h = this.props.image_height
        let img_w = this.props.image_width

        let base_level = 8

        const ofBase = (decimal) => {
            return Math.max(base_level * decimal * fontMultiplier, 4 * fontMultiplier)
        }

        if (img_w > 800 && img_w < 1500) {
            base_level = 10
        } else if(img_w >= 1500) {
            base_level = 15
        }


        if (zoom_level < 2) {
            if (zoom_level >= 1) {
                this.setState({
                    fontSize: ofBase(1.5)
                });
            } else if (zoom_level >= 0) {
                this.setState({
                    fontSize: ofBase(1)
                });
            } else if (zoom_level >= -1) {
                this.setState({
                    fontSize: ofBase(0.75)
                });
            } else if (zoom_level >= -2) {
                this.setState({
                    fontSize: ofBase(0.5)
                });
            } else {
                this.setState({
                    fontSize: ofBase(0)
                });
            }
        } else {
            this.setState({
                fontSize: ofBase(2)
            });
        }
        if (zoom_level > 2) {
            this.setState({
                showCompany: true
            });
        } else {
            this.setState({
                showCompany: false
            });
        }
    }

    onZoomChange = (event) => {
        if (this.state.zoom != event.zoom) {
            if (!this.state.disableZoom) {
                this.setTextSize(event.zoom);
            }
            this.setState({
                zoom: event.zoom
            });
        }
    }



    renderBooths() {
        let enablePopup = this.props.mode == 'public' || this.props.mode == 'cart';
        function isRectangle(coords) {
            if(coords.length != 4) {
                return false;
            }
            function sqr(x) {
                return x * x;
            }
            var cx, cy;
            var dd1, dd2, dd3, dd4;
            cx = (parseInt(coords[0].lat) + parseInt(coords[1].lat) + parseInt(coords[2].lat) + parseInt(coords[3].lat)) / 4;
            cy = (parseInt(coords[0].lng) + parseInt(coords[1].lng) + parseInt(coords[2].lng) + parseInt(coords[3].lng)) / 4;
            dd1 = sqr(cx - parseInt(coords[0].lat)) + sqr(cy - parseInt(coords[0].lng));
            dd2 = sqr(cx - parseInt(coords[1].lat)) + sqr(cy - parseInt(coords[1].lng));
            dd3 = sqr(cx - parseInt(coords[2].lat)) + sqr(cy - parseInt(coords[2].lng));
            dd4 = sqr(cx - parseInt(coords[3].lat)) + sqr(cy - parseInt(coords[3].lng));
            return dd1==dd2 && dd1==dd3 && dd1==dd4;
        }

        const renderToolTip = (lat,lng) => {
            let position;
            let image_lng = this.props.image_width;
            let overLayLat = this.props.image_height / 2; 
            let overLayLng = this.props.image_width / 2;
            if(lat > overLayLat){
                if(lng < (overLayLng * 1/4)){
                    return position = 'right'
                }else if(lng > (image_lng * 3/4)){
                    return position = 'left'
                }
                return position = 'bottom'
            }else{
                if(lng < (overLayLng * 1/4)){
                    return position = 'right'
                }else if(lng > (image_lng * 3/4)){
                    return position = 'left'
                }
                return position = 'top'
            }
        }

        return this.state.undrawn_booths.map((booth, index) => {
            let work_booth = booth;
            let ref_ = "ID" + work_booth['BoothID'];
            let companyname = 'Unassigned';
            let companyLogo = '';
            if(!work_booth.hasOwnProperty('CompID') || work_booth['CompID'] != 0) {
                if(this.props.exhibitors.hasOwnProperty(work_booth['CompID'])){
                    companyname = this.props.exhibitors[work_booth['CompID']].Companyname;
                    companyLogo=this.props.exhibitors[work_booth['CompID']].CompLogo
                }else if(work_booth['CompID']){
                    companyname = 'Company details not found'
                }
            }
            let lat = work_booth.DrawBounds.label.lat;
            let lng = work_booth.DrawBounds.label.lng;
            let isRec = isRectangle(work_booth['DrawBounds']['polygon'][0]);
            let show_cost = (this.numberWithCommas(work_booth['Amount']) != null);

            let popUp = (<Tooltip key={index} opacity={1} className='floorplan-tooltip' sticky direction={renderToolTip(lat, lng)}>
                {fullscreen && this.props.exhibitors[work_booth['CompID']] && this.props.exhibitors[work_booth['CompID']].CompLogo && (<img src={companyLogo} style={{ height: '100%', width: '100%' }}/>)}
                  {(work_booth['CompID'] && !this.props.exhibitors.hasOwnProperty(work_booth['CompID'])) && <div style={{display: 'flex', justifyContent: 'center'}}>
                    <WarningOutlined style={{fontSize:'30px'}} />
                    </div>}
                  <h4 className='gx-my-2'><b>{companyname}</b></h4>
                  <br/><div>Booth: {work_booth.BoothNo}</div>
                  Size: {work_booth['BoothSize']}<br/>
                  {this.props.exhibitors[work_booth['CompID']] && this.props.exhibitors[work_booth['CompID']].sponsor && (<span className="label label-info">Sponsor</span>)}
                  {this.props.mode == 'cart' && !(work_booth.hasOwnProperty('CompID') && work_booth.CompID !=0) && show_cost && (<div>Cost: ${this.numberWithCommas(work_booth['Amount'])}</div>)}
            </Tooltip>)
                let color_key = 'taken';
                if (this.checkBoothClass(work_booth.Class, true)) {
                    if (work_booth.hasOwnProperty('CompID') && work_booth.CompID !=0 ) {
                        // this is a taken booth.
                        color_key = 'taken';
                    } else {
                    // else booth is available.
                    color_key = 'available';
                }
            } else {
                color_key = work_booth.Class;
            }
            let popupDisabled = false;
            if(this.props.public_floorplan_config.hasOwnProperty('ClickableNonSoldBooths') && this.props.public_floorplan_config.ClickableNonSoldBooths && color_key == 'available') {
                popupDisabled = true;
            }
            let props = {
                color: "#000",
                weight: 2,
                fillOpacity: 1,
                fillColor: this.state.color[color_key],
                ref: ref_,
                key: ref_,
                onMouseOver:
                    (e) => {
                        e.target.openPopup();
                    }
                ,
                onMouseOut:
                    (e) => {
                        e.target.closePopup();
                    }

            };
            if(!isRec) {
                return ( <Polygon positions = {work_booth['DrawBounds']['polygon'][0]}
                            {...props}
                    >{enablePopup && this.checkBoothClass(work_booth.Class) && !popupDisabled && popUp}</Polygon>);
            } else {
                return (<Rectangle bounds = {work_booth['DrawBounds']['polygon'][0]} {...props} >
                        {enablePopup && this.checkBoothClass(work_booth.Class) && !popupDisabled && popUp}
                    </Rectangle>)
            }

              });
          }

    renderLegacy() {
        let return_array = [];
        Object.keys(this.state.legacy_booths).map((key, index) => {
            let current = this.state.legacy_booths[key];
            let companyname = 'Unassigned';
            if(!current.hasOwnProperty('CompID') || current['CompID'] != 0) {
                if(this.props.exhibitors.hasOwnProperty(current['CompID'])){
                    companyname = this.props.exhibitors[current['CompID']].Companyname;
                }
            }
            return_array.push({key: key, BoothNo: current['BoothNo'], size: current['BoothSize'], name: companyname});
        });

        return_array.sort(function(a, b){
            return a.name.localeCompare(b.name);
        });
        return return_array.map((obj) => {
            return (<option value={obj.key} key={obj.key}>{obj.BoothNo} (Size: {obj.size}) ({obj.name})</option>);
        });

    }

    renderDiscounts() {
        if (this.state.discounts.length > 0) {
            let i = 0;
            return this.state.discounts.map((discount) => {
                i++;
                return (<div className="form-group" key={`Discount${i}Num`}>
                                  <label className="col-md-4 control-label" htmlFor={`Discount${i}Num`} style={{fontSize: 12}}>Discount: {discount.DiscountName}</label>
                                  <div className="col-md-6">
                                  <input id={`Discount${i}Num`} name={`Discount${i}Num`} type="number"  placeholder=""  defaultValue={this.state.populatedForm.hasOwnProperty('booth_data')?this.state.populatedForm.booth_data['Discount' + i + 'Num']:''}  className="form-control input-md" onChange={this.changeHandler} />
                                  </div>
                                </div>);
            });
        } else {
            return null;
        }
    }

    renderClasses() {
        if(this.props.public_floorplan_config.hasOwnProperty('classes')) {
            return this.props.public_floorplan_config.classes.map((classx) => {
                 return (<option value={classx.value} key={classx.value}>{classx.label}</option>);
            });
        } else { return null; }
    }

    mapUndrawnBooths(undrawnMappedFlag) {
        // Map undrawn booths or persisted booths, whatever we call to
        // master booths state. Hopefully, this method will be invoked from
        // componentDidUpdate().
        this.state.undrawn_booths.map((booth) => {
          this.state.booths[booth['BoothID']] = {
            'booth_data': booth,
            'polygon_layer': this.refs.hasOwnProperty('ID' + booth['BoothID'])?this.refs['ID' + booth['BoothID']].leafletElement:null
          };
          guideLayers.push(this.refs.hasOwnProperty('ID' + booth['BoothID'])?this.refs['ID' + booth['BoothID']].leafletElement:null);
        });
        this.setState({booths: this.state.booths, undrawnMapped: undrawnMappedFlag});
    }

    shouldComponentUpdate(nextProps, nextState) {
        if(this.state.zoom != nextState.zoom){
            return false;
        }
        if (this.state.undrawnMapped != nextState.undrawnMapped) {
            console.log('render cancelled');
            return false;
        }
        if (this.state.form != nextState.form && this.state.showNewBoothModal && !nextState.form == {}) {
            console.log('render cancelled');
            return false;
        }
        return true;
    }
    //open company modal based on scaenrio
    handleCompanyModalpopup = (boothData) => {
        if (boothData.CompID != 999999 && boothData.CompID != 0&&!_isEmpty(this.props.exhibitors[boothData.CompID])) {
            return true
        }else{
            return false
        }
    }
    // Invokes on polygon click.
    selectPolygon(event) {
        if (!this.state.undrawnMapped) {
            this.mapUndrawnBooths(true);
        }
        let booth = null;
        // if component was initialized with edit option.
        Object.keys(this.state.booths).forEach(function(booth) {
            if (this.state.booths[booth].polygon_layer == event.layer) {
                // This booth has been clicked.
                // Todo convert this finding loop into a method.
                //
                // if edit mode.
                if (this.props.mode == 'edit' && this.checkBoothClass(this.state.booths[booth].booth_data.Class)) {
                    this.setState({
                        modalType: 'update',
                        showNewBoothModal: true,
                        form: {...this.state.booths[booth].booth_data
                        },
                        populatedForm: {...this.state.booths[booth]
                        }
                    });
                    // if public mode.
                } else if (this.props.mode == 'public' && this.checkBoothClass(this.state.booths[booth].booth_data.Class)) {
                    // Only open modal if company is assigned to the selected
                    // booth.
                    if (this.state.booths[booth].booth_data.hasOwnProperty('CompID')) {
                        let CompID = this.state.booths[booth].booth_data['CompID'];
                        let isOpen= this.handleCompanyModalpopup(this.state.booths[booth].booth_data)
                        if (isOpen) {
                            this.setState({
                                showExhibitorModal: true,
                                selectedExhibitor: CompID,
                                selectedBoothID: booth
                            });
                        }
                    }
                    // if cart mode.
                } else if (this.props.mode == 'cart' && this.checkBoothClass(this.state.booths[booth].booth_data.Class) && this.state.cartList.indexOf(this.state.booths[booth]) == -1){
                    let positiveAction = () => {
                        if(!((this.state.cartList.length + this.state.registeredList.length) >= MaxBoothSelection)) {
                            this.setState({selectedBoothID: booth, showCartConfirmationModal: true});
                        }
                    }
                    // Open allow positiveAction only if booth is NOT assigned.
                    if (!this.state.booths[booth].booth_data.hasOwnProperty('CompID')) {
                        positiveAction();
                    } else if(this.state.booths[booth].booth_data['CompID'] == 0) {
                        positiveAction();
                    }

                }
            }
        }, this);
        // if click is registered on marker and not polygon layer.
        if (event.layer.hasOwnProperty('dragging') && event.layer['dragging'].hasOwnProperty('_marker')) {
            let booth = parseInt(event.layer.options.alt);
            if (this.props.mode == 'public') {
                // Only open modal if company is assigned to the selected
                // booth.
                this.openCompanyPopup(booth);
            }
        }

    }

    openCompanyPopup(booth_id) {
        // close popup from modal as well if there
        if (this.state.selectedBoothID != 0){
            this.state.booths[this.state.selectedBoothID].polygon_layer.closePopup();
        }
        if (this.state.booths[booth_id].booth_data.hasOwnProperty('CompID')) {
            this.state.booths[booth_id].polygon_layer.closePopup();
            let CompID = this.state.booths[booth_id].booth_data['CompID'];
            let isOpen= this.handleCompanyModalpopup(this.state.booths[booth_id].booth_data)
            if(isOpen) {
                this.setState({
                    showExhibitorModal: true,
                    selectedExhibitor: CompID,
                    selectedBoothID: booth_id
                });
            }
        }
    }
    highlightBooth(booth_id){
        this.setState({showExhibitorModal: false});
        this.state.booths[booth_id].polygon_layer.openPopup();
    }

    // Lifecycle Method: componentDidUpdate

    handleDrawerState = () => {
        if( window.innerWidth > 991){
            this.setState({ drawerVisible: false })
        }else{
            this.setState({isExhibtorButton: true})
        }
    }

    componentDidMount() {
        this.handleDrawerState();
        window.addEventListener("resize", this.handleDrawerState);
        let color  = this.state.color;
        if (this.props.public_floorplan_config.hasOwnProperty('AvailableBoothColor')) color.taken = this.props.public_floorplan_config['NotAvailableBoothColor'];
        if (this.props.public_floorplan_config.hasOwnProperty('NotAvailableBoothColor')) color.available = this.props.public_floorplan_config['AvailableBoothColor'];
        if(this.props.public_floorplan_config.hasOwnProperty('classes')){
            this.props.public_floorplan_config.classes.map((classx)=>
            {
                color[classx.value] = classx.color;
            });
        }
        
        this.setState({color: color});
        window.addEventListener("resize", this.updateDimensions.bind(this));
        
        if(this.header_div) {
            this.setState({headerHeight: this.header_div.clientHeight});
        } else {
            this.setState({headerHeight: 0});
        }

        // Initialize Zoom
        const map = this.refs.map.leafletElement;
        const currentZoom = map.getZoom();
        this.setState({zoom: currentZoom});
        
        // Initial fontMultiplier
        let initialFontMultiplier = 1;

        if (this.props.public_floorplan_config.hasOwnProperty("fontMultiplier")) {
            this.setState({ fontMultiplier: this.props.public_floorplan_config.fontMultiplier });
            initialFontMultiplier = this.props.public_floorplan_config.fontMultiplier;
        }

        // Set initial text size (will get triggered by zoom change after this point)
        this.setTextSize(currentZoom, initialFontMultiplier)
            
    }


    componentWillUnmount() {
        window.removeEventListener("resize", this.handleDrawerState);
    }


    renderEditControl() {
        return (<EditControl
                  position='topright'
                  onCreated={(event)=>{this.onCreated(event)}}
                  showArea={false}
                  showLength={false}
                  draw={{
                      polyline: false,
                      polygon: {showArea: false, allowInteraction: false, guideLayers: guideLayers, snapDistance: 100},
                      rectangle: {showArea: false, allowInteraction: false},
                      circle: false,
                      marker: false,
                      circlemarker: false
                  }}
                  onEditStart={this.editToggle}
                  onEditStop={this.editToggle}
                  ref='editControl'
                  edit={{ remove: false }}
                  onEdited={this.onEdited}
                />);
    }


    handleExhibitorModalClose() {
        this.setState({showExhibitorModal: false});
    }

    handleConfirmModalClose() {
        this.setState({showCartConfirmationModal: false});
    }

    handleErrorModalClose() {
        this.setState({showError: false});
    }

    sortAndFilterBooths(booth_list){
        // search
        let new_list = [];
        if (this.state.filterText != '') {
            for (let i = 0; i < booth_list.length; i++) {
                let temp = this.state.booths[booth_list[i]]['booth_data'];
                if (temp.hasOwnProperty('CompID') && this.props.exhibitors.hasOwnProperty(temp['CompID'])) {
                    const query = (this.state.filterText || "").toLocaleLowerCase();
                    const companyDetails = (JSON.stringify(this.props.exhibitors[temp['CompID']]) || "").toLocaleLowerCase();
                    const boothNo = (temp['BoothNo'] || "").toString().toLocaleLowerCase();
                    if (companyDetails.includes(query) || boothNo.includes(query)) {
                        new_list.push(booth_list[i]);
                    }
                }
            }
        } else {
            new_list = booth_list;
        }
        // sorting
        new_list = _sortBy(new_list,(i => {
            let CompID = this.state.booths[i]?.booth_data?.CompID
            let company = this.props.exhibitors[CompID];
            if (company && company.hasOwnProperty('support_level')) {
                let supportLevel = _find(this.props.config['sponsor_config'], { label: company.support_level })
                return [parseInt((supportLevel?.order ?? '99')),company.Companyname.toLocaleLowerCase()]
            }
            // if there is lack of information, record will be moved to the last
            return [99,'z'] // 99 - to order by sponsorship, z -  to order by the name of company
        }))
        // filtering
        if (this.state.onlySponsor) {
            new_list = new_list.filter(booth_id => {
                if(this.props.exhibitors[this.state.booths[booth_id]['booth_data']['CompID']]) {
                    if(this.props.exhibitors[this.state.booths[booth_id]['booth_data']['CompID']].sponsor){
                        return true;
                    } else {
                        return false;
                    }
                }
            });
        }

        // Advance search filtering
        if (!_isEmpty(this.props.selectedItems)) {
            new_list = new_list.filter(booth_id => {
                if(this.props.exhibitors[this.state.booths[booth_id]['booth_data']['CompID']]) {
                    let exhibitor = this.props.exhibitors[this.state.booths[booth_id]['booth_data']['CompID']];
                    let result = _map(this.props.selectedItems, (search, key) => {
                        let res = exhibitor.tags.filter(tag => {
                            return search.includes(tag.toString());
                        })
                        return !_isEmpty(res)
                    })
                    return result[0];
                }
            });
        }
        
        return new_list;
    }

    filterChangeHandler = event => this.setState({ filterText: event.target.value });

    updateSearch = (search) => {
        this.sortAndFilterBooths(Object.keys(this.state.booths))
    }

    handleAdvanceSearch=(search)=>{
        this.setState({ drawerVisible: false })
        if(!_isEmpty(search)){
            this.setState({ drawerVisible: false, isAdvancedSearch :false })
        }
    }

    showDrawer = () => {
        this.setState({drawerVisible: true})
    };
    renderTabContent = (primaryColor,fullscreen,calculatedHeight) => {
        return !this.state.isAdvancedSearch ?
              <ExhibitorList
                {...this.state}
                {...this.props}
                filterChangeHandler={this.filterChangeHandler}
                sortedBooths={this.sortAndFilterBooths(Object.keys(this.state.booths))}
                openCompanyPopup={this.openCompanyPopup}
                highlightBooth={this.highlightBooth}
                setOnlySponser={() => this.setState({ onlySponsor: !this.state.onlySponsor })}
                primaryColor={primaryColor}
                fullscreen={fullscreen}
                advancedSearch={this.props.selectedItems}
                handleCardContent={this.handleCardContent}
                calculatedHeight={calculatedHeight}
            /> : <Search
                {...this.state}
                {...this.props}
                primaryColor={primaryColor}
                updateSearch={(search) => this.handleAdvanceSearch(search)}
                handleCardContent={this.handleCardContent}
                calculatedHeight={calculatedHeight}
            />
    }
    handleCardContent = type => {
        if (type === 'advanced_search') {
            this.setState({ isAdvancedSearch: true })
        } else {
            this.setState({ isAdvancedSearch: false })
        }
    }
    // Lifecycle Method: render
    render() {
      let image_height = this.props.image_height;
      let image_width = this.props.image_width;
      let floorplan = this.props.floorplan;
      let primaryColor = this.props.public_floorplan_config.hasOwnProperty('primaryColor')? this.props.public_floorplan_config['primaryColor']: "#000";
    //   let leafletHeight = fullscreen?this.state.height-this.state.headerHeight:'600px';
      let leafletHeight = '400px';
      let matchData = this.sortAndFilterBooths(Object.keys(this.state.booths))
      let greenMarkerIcon = new L.Icon({
        iconUrl:require('../../assets/images/marker-icon-2x-green.png'),
        shadowUrl:require('../../assets/images/marker-shadow.png'),
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
      });
        
        let layoutResult = {col1: 'col-sm-9', col2: 'col-sm-3'};
        let windowHeight = window.innerHeight
        let windowWidth = window.innerWidth;
        let calculatedHeight =  window.innerHeight-200;
        if(windowWidth > 1520){
            layoutResult = {col1: 'col-sm-9', col2: 'col-sm-3'}
        }else if(windowWidth <= 1440 && windowWidth >= 1024){
            layoutResult = {col1: 'col-sm-8', col2: 'col-sm-4'}
        } else if (windowWidth < 1024) {
            layoutResult = {col1: 'col-sm-12'}
            calculatedHeight = windowHeight-250
        }
        if (windowWidth < 992) {
            calculatedHeight = windowHeight - 300
        }


        let minZoom = Math.log( ((1-displayConstants.minZoomConstant) * (calculatedHeight - 48 /*Card padding*/) ) / image_height )    / Math.log(2)
        minZoom = -3;
        let maxZoom = 4
        let smallBoothHeight = displayConstants.maxZoomConstant + 1
        let largeBoothHeight = 0
        Object.keys(this.state.labels).forEach((boothNo) => {
            if (smallBoothHeight == -1) {
                smallBoothHeight = this.state.labels[boothNo].baseSize.height
            } else if (this.state.labels[boothNo].baseSize.height < smallBoothHeight) {
                smallBoothHeight = this.state.labels[boothNo].baseSize.height
            }
            if (this.state.labels[boothNo].baseSize.height > largeBoothHeight) {
                largeBoothHeight = this.state.labels[boothNo].baseSize.height
            }
        })
        // Next line breaks zooming. If we want dynamic maxZoom, calculation below is correct, but we have to figure out why it breaks zoom.
        // maxZoom = Math.log( displayConstants.maxZoomConstant / smallBoothHeight )   / Math.log(2)
        let zoomDelta = (-minZoom + maxZoom) / ( image_height / smallBoothHeight )


      if(image_height && image_width && floorplan) {
      return (
      
      <div>
          {/* If fullscreen and public view show the header */}
          <div className={`${this.props.isEmbed ? '' : `row gx-ml-4 gx-mr-4 ${window.innerWidth >= 1024 ? "gx-mt-5" : "gx-mr-4"}`}`}>
              {/* Leaflet Component */}
                  <div className={`${this.props.isEmbed ? "col-sm-12" : layoutResult['col1']}`}>
                {window.innerWidth < 1024 && !this.props.isEmbed && this.state.isExhibtorButton && <div style={{ marginTop: 16 }} className=' gx-text-right gx-d-xs-block'>
                    <Button type="default" onClick={this.showDrawer} className='app-text-backgroundcolor floor-card-shadow '>
                        Exhibitor List
                    </Button>
                  </div>}
                  {this.props.isEmbed && 
                  <div className='gx-text-right'>
                  <Button type="default" onClick={this.showDrawer} className='gx-m-3 gx-ml-auto app-text-backgroundcolor floor-card-shadow '>
                      Exhibitor List
                    </Button>
                  </div>
                    }
                 <Card className='gx-card-widget card-border-radius floor-card-shadow' style={{ height: calculatedHeight}}>
                  <LeafletMap
                  onViewportChanged={this.onZoomChange}
                  attributionControl={false}
                  drawControl={false}
                  bounds={[[0,0],[image_height, image_width-100]]}
                  maxBounds={[[0,0],[image_height, image_width + 100]]}
                  zoomSnap={0.2}
                  zoomControl={true}
                  zoomDelta={0.2}
                  wheelPxPerZoomLevel={160}
                  maxZoom={maxZoom}
                  minZoom={minZoom}
                  ref="map"
                  crs={CRS.Simple}
                  style={{ height: calculatedHeight - 50, background:"#FFF"}}
                  >
                    <ImageOverlay url={floorplan} bounds={[[0,0],[image_height , image_width]]} />
                      <FeatureGroup ref={this.featureGroup}  onClick={this.selectPolygon}>
                        {this.props.mode=='edit'?this.renderEditControl():null}
                        {this.renderBooths()}
                        {this.renderMarkers()}
                    </FeatureGroup>
                    {(this.state.filterText || !_isEmpty(this.props.selectedItems)) && matchData.map(item => {
                        let data = this.state.booths[parseInt(item)]['booth_data']['DrawBounds']
                        return (
                            <Marker map={this.refs.map} position={data?.label} icon={greenMarkerIcon} />
                        )
                    })}
                  </LeafletMap>
                  </Card>
              </div>
              <div className={`gx-p-0 ${layoutResult['col2']}`} >
                    {/* Exhibitor list *//* If public view show left list of exhibitors*/}
                    {window.innerWidth >= 1024 && !this.props.isEmbed ? <div className='exhibitor-card card-border-radius' style={{height: calculatedHeight}} >
                        <Spin className="exhibitor-loader" spinning={this.props.boothsRequestLoader} indicator={<LoadingOutlined/>}>
                            {this.renderTabContent(primaryColor,fullscreen,calculatedHeight)}
                        </Spin>
                    </div>: 
                    <div className={this.props.isEmbed ? 'embedDrawer drawerAlignment' : "drawerAlignment"}>
                        <Drawer
                            placement={"right"}
                            closable={false}
                            onClose={() => this.setState({ drawerVisible: false })}
                            visible={this.state.drawerVisible}
                            getContainer={false}
                            bodyStyle={{ maxWidth: 450, width: 320, overflow: "hidden" }}
                        >
                            {this.renderTabContent(primaryColor,fullscreen,calculatedHeight)}
                        </Drawer>
                    </div>
                    }
                 </div>
          {/* If cart mode */}
          {this.props.mode == 'cart' && (

            <div className="col-sm-4 col-md-4">
                <Cart selectedBooths={this.state.cartList}
                      removeFromCart={this.removeFromCart.bind(this)}
                      booths={this.state.booths}
                      registeredBooths={this.state.registeredList}
                      checkoutLength={CheckoutLength}
                      maximumSelectionAllowed={MaxBoothSelection}
                      MenuID={MenuID}
                      Screen={Screen}
                      SESSION={SESSION}
                      />
            </div>)}
          </div>
          {this.state.text && 
            <div className="row">
                <div className="col-sm-12">{this.state.text}</div>
            </div>
          }
               {/* Modals */}
               {/* Modal: Add or update booth */}
               <Modal show={this.state.showNewBoothModal} onHide={this.handleClose} style={{opacity:this.state.showNewBoothModal?1:0}} dialogClassName="specialModal">
                  <Modal.Header>
                    <Modal.Title>{this.state.modalType=='new'?'New':'Update'}</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                  <div>
                  {this.state.modalType == 'new' && (
                    <ul className="nav nav-tabs" role="tablist">
                      <li role="presentation" className="active"><a href="#new_booth" aria-controls="new_booth" role="tab" data-toggle="tab"  onClick={(e)=>{this.setState({activeTab: 1});}}>New Booth</a></li>
                      <li role="presentation"><a href="#assign" aria-controls="assign" role="tab" data-toggle="tab" onClick={(e)=>{this.setState({activeTab: 2});}}>Transfer from floorplan v1</a></li>
                    </ul>
                  )}
                    <div className="tab-content">
                          <div role="tabpanel" className="tab-pane active" id="new_booth">

                                 <form className="form-horizontal" onSubmit={this.saveBooth}>
                                      <fieldset style={{paddingTop: 10}}>
                                       <div className="form-group">
                                        <label className="col-md-4 control-label" htmlFor="BoothNo">Booth Label *</label>
                                        <div className="col-md-6">
                                        <input id="BoothNo" name="BoothNo" type="text" placeholder="" defaultValue={this.state.populatedForm.hasOwnProperty('booth_data')?this.state.populatedForm.booth_data.BoothNo:''} className="form-control input-md" required onChange={this.changeHandler} />
                                        </div>
                                      </div>
                                      <div className="form-group">
                                        <label className="col-md-4 control-label" htmlFor="BoothSize">Booth Size</label>
                                        <div className="col-md-6">
                                        <input id="BoothSize" name="BoothSize" type="text" placeholder=""  defaultValue={this.state.populatedForm.hasOwnProperty('booth_data')?this.state.populatedForm.booth_data.BoothSize:''}  className="form-control input-md" onChange={this.changeHandler} />
                                        </div>
                                      </div>
                                      <div className="form-group">
                                        <label className="col-md-4 control-label" htmlFor="Amount">Amount</label>
                                        <div className="col-md-6">
                                        <input id="Amount" name="Amount" type="number" placeholder=""  defaultValue={this.state.populatedForm.hasOwnProperty('booth_data')?this.state.populatedForm.booth_data.Amount:''}  className="form-control input-md" onChange={this.changeHandler} />
                                        </div>
                                      </div>
                                      <div className="form-group">
                                        <label className="col-md-4 control-label" htmlFor="Deposit">Deposit amount</label>
                                        <div className="col-md-6">
                                        <input id="Deposit" name="Deposit" type="number" placeholder=""  defaultValue={this.state.populatedForm.hasOwnProperty('booth_data')?this.state.populatedForm.booth_data.Deposit:''} className="form-control input-md"  onChange={this.changeHandler} />
                                        </div>
                                      </div>
                                      <div className="form-group">
                                        <label className="col-md-4 control-label" htmlFor="selectbasic">Company</label>
                                        <div className="col-md-6">
                                          <select id="selectbasic" name="CompID" className="form-control" onChange={this.changeHandler}  defaultValue={this.state.populatedForm.hasOwnProperty('booth_data')?this.state.populatedForm.booth_data.CompID:''} >
                                            <option value="">Unassigned</option>
                                            <option value="999999">On-Hold</option>
                                            {this.renderCompanies()}
                                          </select>
                                        </div>
                                      </div>
                                      <div className="form-group">
                                        <label className="col-md-4 control-label" htmlFor="selectbasic">Booth Type</label>
                                        <div className="col-md-6">
                                          <select id="selectbasic" name="Class" className="form-control" onChange={this.changeHandler}  defaultValue={this.state.populatedForm.hasOwnProperty('booth_data')?this.state.populatedForm.booth_data.Class:''} >
                                            <option value="Booth">Booth</option>
                                            {this.renderClasses()}
                                          </select>
                                        </div>
                                      </div>
                                      <hr/>
   {/*                                   <div className="form-group">
                                        <label className="col-md-4 control-label" htmlFor="OnHold">On Hold</label>
                                        <div className="col-md-6">
                                        <select id="selectbasic" name="OnHold" className="form-control"  onChange={this.changeHandler}  defaultValue={this.state.populatedForm.hasOwnProperty('booth_data')?this.state.populatedForm.booth_data.OnHold:''}>
                                              <option value="0">No</option>
                                              <option value="1">Yes</option>

                                        </select>
                                        </div>
                                      </div>*/}
                                      <div className="form-group">
                                        <label className="col-md-4 control-label" htmlFor="BoothNotes">Booth Notes</label>
                                        <div className="col-md-6">
                                        <textarea id="BoothNotes" name="BoothNotes" placeholder=""  defaultValue={this.state.populatedForm.hasOwnProperty('booth_data')?this.state.populatedForm.booth_data.BoothNotes:''}  className="form-control input-md" onChange={this.changeHandler} />
                                        </div>
                                      </div>
                                      <div className="form-group">
                                        <label className="col-md-4 control-label" htmlFor="Description">Description</label>
                                        <div className="col-md-6">
                                        <textarea id="Description" name="Description"  placeholder=""  defaultValue={this.state.populatedForm.hasOwnProperty('booth_data')?this.state.populatedForm.booth_data.Description:''}  className="form-control input-md" onChange={this.changeHandler} />
                                        </div>
                                      </div>
                                      {this.renderDiscounts()}
                                  </fieldset>
                                {this.state.activeTab == 1 &&
                                  <Modal.Footer>
                                      <Button type="submit">Save</Button>
                                      <Button onClick={this.cancel} variant="danger">Cancel</Button>
                                      {
                                        this.state.modalType=='update' &&
                                        <Button  data-toggle="modal" data-target="#confirm-delete" variant="danger">Delete</Button>
                                      }
                                  </Modal.Footer>
                                  }
                                  </form>
                                  </div>
                                  <div role="tabpanel" className="tab-pane" id="assign">
                                  <form className="form-horizontal" onSubmit={this.saveBooth}>
                                   <fieldset style={{paddingTop: 10}}>
                                      <div className="form-group">
                                        <label className="col-md-4 control-label" htmlFor="selectbasic">Existing booths:</label>
                                        <div className="col-md-6">
                                          <select id="selectbasic" name="legacy_BoothID" className="form-control" onChange={this.changeHandler} >
                                            <option value=""></option>
                                            {this.renderLegacy()}
                                          </select>
                                        </div>
                                      </div>
                                  </fieldset>

                                  <Modal.Footer>
                                      <Button type="submit">Save</Button>
                                      <Button onClick={this.cancel} variant="danger">Cancel</Button>
                                  </Modal.Footer>
                                </form>
                      </div>

                    </div>

                  </div>

                  </Modal.Body>


                    <div className="modal fade" id="confirm-delete" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                      <div className="modal-dialog">
                          <div className="modal-content">
                              <div className="modal-header">
                                  Confirm deletion.
                              </div>
                              <div className="modal-body">
                                  Please confirm that you want to delete the booth. Association with exhibitor will be lost if the booth is assigned.
                              </div>
                              <div className="modal-footer">
                                  <button type="button" className="btn btn-default" data-dismiss="modal">Cancel</button>
                                  <a className="btn btn-danger btn-ok" onClick={this.delete} data-dismiss="modal">Delete</a>
                              </div>
                          </div>
                      </div>
                  </div>

               </Modal>
               {/* Modal: Exhibitor Profile */}
               {this.state.showExhibitorModal && <ExhibitorProfile
               show={this.state.showExhibitorModal}
               onHide={this.handleExhibitorModalClose.bind(this)}
               fullscreen={fullscreen}
               selectedExhibitor={this.state.selectedExhibitor}
               exhibitors={this.props.exhibitors}
               exhibitorsInfo={this.props.exhibitorsInfo}
               tagsInfo={this.props.tags}
               handleExhibitorModalClose={this.handleExhibitorModalClose.bind(this)}
               selectedBoothID={this.state.selectedBoothID}
               booth={this.state.booths[this.state.selectedBoothID]}
               highlightBooth={this.highlightBooth.bind(this)}
               customThemeStyle={this.props.customThemeStyle}
               logoBase={`https://www.xcdsystem.com/${this.props.source_hex}/CompLogo/`}/>}
               {/* Model: Confirmation Modal */}
               {this.state.showCartConfirmationModal && <ConfirmationModal show={this.state.showCartConfirmationModal}
               onHide={this.handleConfirmModalClose.bind(this)}
               handleConfirmModalClose={this.handleConfirmModalClose.bind(this)} 
               selectedBooth={this.state.booths[this.state.selectedBoothID]}
               addToCart={this.addToCart.bind(this)}
               customThemeStyle={this.props.customThemeStyle}
               />}
              {this.state.showError && <ErrorModal show={this.state.showError}
               errorText={this.state.errorText}
               customThemeStyle={this.props.customThemeStyle}
               handleModalClose={this.handleErrorModalClose.bind(this)}
               onHide={this.handleErrorModalClose.bind(this)}
               />}
      </div>
    );
      }
      else {
        return (<div></div>);
      }
    }
}


const mapStateToProps = ({exhibFloor}) => {
    return {
        selectedItems: exhibFloor.selectedItems,
        queryParams: exhibFloor.queryParams,
        companyInfo: exhibFloor.companyInfo,
        exhibitors: exhibFloor.exhibitors,
        exhibitorsInfo: exhibFloor.exhibitorsInfo,
        boothsRequestLoader: exhibFloor.boothsRequestLoader,
        customThemeStyle: exhibFloor.customThemeStyle,
        config: exhibFloor.config,
        tagCategories: exhibFloor.tagCategories,
        isEmbed: exhibFloor.isEmbed,
    }
}


export default connect(mapStateToProps, {handleBoothListLoader})(LMap);